import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
import logEmptyFunctionWarning from "../functions/logEmptyFunctionWarning";
import validateSections from "../functions/validateSections";
export class ValidateDragSystem extends SystemBase {
    constructor(services) {
        super(ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID);
        this.services = services;
        this.id = "AutomaticGroupDragSystem";
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.doingChangesOnComponent = [];
    }
    onAddComponent(_entity, _newComponent) { }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        logEmptyFunctionWarning("onUpdateComponent", this.id);
    }
    onRemoveComponent(_entity, _newComponent) {
        validateSections(this.services, _newComponent, "uprights");
    }
}
